import React, { useMemo } from "react";
import * as geolib from "geolib";
import { ShipInformation } from "adoms-common-lib"
import { Layer, Marker, Source } from 'react-map-gl';
import { Typography } from "@mui/material";
import NavigationIcon from '@mui/icons-material/Navigation';

type ShipPositionPredictionProps = {
    aisInfo: ShipInformation
};

type PredictedPointListType = {
    latitude: number;
    longitude: number;
    time: number;
};

/**
 * 船舶の地点予測計算
 * @param aisDetailInfo
 */
const getPredictedPositions = (aisDetailInfo: ShipInformation): PredictedPointListType[] => {
    const lat: number = aisDetailInfo.latitude;
    const lon: number = aisDetailInfo.longitude

    // 緯度経度のチェック
    if (lat == null || lon == null) {
        return [];
    };

    const speed: number = aisDetailInfo.speedOverGround;
    const heading: number = aisDetailInfo.courseOverGround;

    // 対地速度と船舶方向のチェック
    if (speed == 0 || heading == 360) {
        return [];
    };

    const predictedMinutes: number[] = [5, 10, 15, 20, 30];

    const predictedPointList: PredictedPointListType[] = predictedMinutes.map(minute => {
        const distanceMeter: number = ((speed * 1.852) / 60) * minute * 1000;
        const predictedPoint = geolib.computeDestinationPoint(
            { latitude: lat, longitude: lon },
            distanceMeter,
            heading
        );
        return {
            latitude: predictedPoint.latitude,
            longitude: predictedPoint.longitude,
            time: minute,
        };
    });
    return predictedPointList;
};

/**
 * 船舶の予測位置を表示する
 * @param props 
 * @returns 
 */
export const ShipPositionPrediction: React.FC<ShipPositionPredictionProps> = (props) => {

    const predictedPositions = useMemo(() => {
        return getPredictedPositions(props.aisInfo);
    }, [props.aisInfo]);

    if (predictedPositions.length === 0) {
        return null;
    };

    const predictedGeoJSON: GeoJSON.Feature = {
        "type": "Feature",
        "geometry": {
            "type": "LineString",
            "coordinates": [
                [props.aisInfo.longitude, props.aisInfo.latitude],
                ...predictedPositions.map((pos) => [pos.longitude, pos.latitude])
            ]
        },
        properties: null
    };

    return (
        <>
            <Source id="straightLine-source" type="geojson" data={predictedGeoJSON}>
                <Layer
                    id="straight-line"
                    type="line"
                    paint={{
                        "line-color": "#000000",
                        "line-width": 2,
                        "line-dasharray": [2, 1],
                    }} />
            </Source>

            {predictedPositions.map((predictedPoint) => (
                <Marker
                    key={predictedPoint.time}
                    latitude={predictedPoint.latitude}
                    longitude={predictedPoint.longitude}
                    rotation={props.aisInfo.courseOverGround}
                >
                    <Typography
                        sx={{
                            left: '18px',
                            fontSize: '11px',
                            position: 'absolute',
                            fontWeight: 'bold',
                            whiteSpace: 'nowrap',
                            transform: `rotate(${-props.aisInfo.courseOverGround}deg)`,
                        }}>
                        {predictedPoint.time}分
                    </Typography>
                    <NavigationIcon
                        color="action"
                        sx={{ fontSize: '20px' }}
                    />
                </Marker>
            ))};
        </>
    );
};